import React, { useEffect } from 'react';
import styled from 'styled-components';
import MobileConvertWrapper from './MobileConvertWrapper';
import LogoWave from './LogoWave';
interface LoadingProps {
  isLoading: boolean;
}

const Loading: React.FC<LoadingProps> = ({ isLoading }) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (isLoading) {
        e.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isLoading]);

  return (
    <LoadingOverlay $isVisible={isLoading}>
      <MobileConvertWrapper
        onlyMobileChildren={<LogoWave size={'mobile'} />}
        onlyNotMobileChildren={<LogoWave size={'standard'} />}
      />
    </LoadingOverlay>
  );
};

const LoadingOverlay = styled.div<{ $isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(235, 235, 235, 0.1);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;

  // /* 불투명도와 트랜지션 */
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transition: opacity 0.4s ease-in-out;

  pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};
`;


export default Loading;